import {Injectable} from '@angular/core';

/**
 * Translations for alert service.
 */
@Injectable()
export class TixxSelectTranslationsService {
  public i18nSuccessCreateLottery: any = $localize`:@@alertService.success.createLotterySucess:Lottery was created successfully!`;
  public i18nSuccessUpdateLottery: any = $localize`:@@alertService.success.updateLotterySucess:Lottery was updated successfully!`;
  public i18nLotterySeatingInitiated: any = $localize`:@@alertService.success.lotterySeatingeatingInitiated:The lottery and seating process was started successfully. The latest status can be seen on the dashboard.`;
  public i18nErrorCreateLottery: any = $localize`:@@alertService.error.createLotteryError:Error occurred. Lottery could not be created.`;
  public i18nErrorUpdateLottery: any = $localize`:@@alertService.error.updateLotteryError:Error occurred. Lottery could not be updated.`;
  public i18nErrorInvalidCredentials: any = $localize`:@@alertService.error.invalidCredentialsError:An error occurred when fetching available events from Tixx. Credentials are invalid.`;
  public i18nErrorFetchingEvents: any = $localize`:@@alertService.error.fetchingEventsError:An error occurred when fetching available events from Tixx. Please make sure that there are Tixx events bookable in the Tixx-Select branch.`;
  constructor() { }
}
